/**
 * The type-specific half of a `draft_items` agent's settings page (Scribe). It
 * has no switches of its own: it runs only when a person uses it on the Scribe
 * page, so this panel says where that is.
 */

import { Link } from 'react-router-dom';
import type { BehaviorSettingsPanelProps } from './types';

export function DraftItemsSettings(_props: BehaviorSettingsPanelProps) {
  return (
    <div className="card space-y-2">
      <h3 className="text-sm font-semibold text-[var(--text-pri)]">Where people use it</h3>
      <p className="text-xs text-[var(--text-ter)]">
        Anyone who can create items uses it on the Scribe page: type or dictate, then keep, edit or skip each draft.
      </p>
      <Link to="/prioritization/scribe" className="text-xs underline text-[var(--text-sec)]">Open Scribe</Link>
    </div>
  );
}
